<!-- 底座历史数据 -->
<template>
    <div class="uk-padding-small h-100 border-box">
        <h1 class="uk-text-center bolder font-16">{{ SearchForm.plinthNo }}</h1>
        <div class="hr bg-gray"></div>
        <div class="uk-flex uk-flex-between uk-flex-middle">
            <div>
                <span class="mr-5">{{ $t('integration.time') }}</span>
                <el-date-picker :value-format="'timestamp'" v-model="timeRange" type="datetimerange" range-separator="To">
                </el-date-picker>
            </div>
            <div>
                <el-button type="primary" @click="analData">{{ $t('integration.analyze_data') }}</el-button>
            </div>
        </div>

        <EchartTab @unitChange="unitChange" @downLoad="download"></EchartTab>
        <div class="border uk-margin-small-bottom">
            <Chart :unitObj="unitObj" :echartObj="chartData"></Chart>
        </div>

        <div class="uk-flex" style="height: calc(100% - 450px);">
            <div style="width: 200px;overflow-y: auto;" class="border border-box uk-padding-small r-5">
                <template v-if="deviceList.length">
                    <div v-for="item in deviceList" @click="selectDevice(item)" :class="{ active: item === activeDeviceId }"
                        :key="item.id" class="mb-10 lh-30 uk-text-center border cursor-pointer" style="border-radius: 5px;">
                        {{ item }}
                    </div>
                </template>
                <template v-else>
                    <div class="h-100">
                        <span class="empty text-middle">{{ $t('integration.no_data_temporarily') }}</span>
                    </div>
                </template>
            </div>

            <div class="uk-flex-1 border ml-5 uk-padding-small" v-if="tableData.length">
                <div class="uk-flex uk-flex-between uk-flex-middle">
                    <el-date-picker :value-format="'timestamp'" v-model="deviceTimeRange" type="datetimerange"
                        range-separator="To"> </el-date-picker>
                    <div>
                        <el-button type="primary" @click="viewData">
                            {{ $t('integration.viewing_data') }}
                        </el-button>
                        <el-button type="primary">
                            {{ $t('integration.fill_preview') }}
                        </el-button>
                        <el-button type="primary">
                            {{ $t('integration.fill_in_data') }}
                        </el-button>
                    </div>
                </div>
                <div class="hr bg-gray"></div>

                <Table :tableData="tableData"></Table>
                <Pagination :total="total" class="uk-flex uk-flex-right" :page.sync="SearchForm.iDisplayStart"
                    :limit.sync="SearchForm.iDisplayLength" @pagination="getDeviceInfo"></Pagination>
            </div>
            <div v-else class="h-100 uk-flex-1 border ml-5 uk-padding-small">
                <span class="empty text-middle">{{ $t('integration.no_data_temporarily') }}</span>
            </div>
        </div>
        <ExportDialog :isShow.sync="exportDiaShow" :searchForm="eForm" ref="dia" :comNmae="exportBaseHistory" />
    </div>
</template>

<script>
import EchartTab from '@/pages/equipment/sensor/echart/EchartTab.vue';
import Chart from '@/pages/equipment/sensor/echart/EchartContent';
import Table from './components/Table.vue';
import { getHistoryData, exportBaseHistory } from '@/api/modules/base';
import unitArray from '@/pages/equipment/base/win/BaseHistory/config/unitArray';
import store from '@/store';
import ExportDialog from '@/pages/count/component/exportDialog.vue';
export default {
    components: {
        EchartTab,
        Chart,
        Table,
        ExportDialog
    },
    data() {
        return {
            timeRange: [0, 0],
            deviceTimeRange: [1688054400000, 1688400000000],
            loading: false,
            total: 0,
            token: '',
            SearchForm: {
                plinthNo: '',
                tab: 0,
                block: 1,
                from: 1688054400000,
                to: 1688400000000,
                dataSort: 0,
                pageSort: 1,
                probe: 'temp',
                iDisplayStart: 0,
                iDisplayLength: 10
            },
            deviceList: [],
            activeDeviceId: null,
            unitObj: {},
            unitArray,
            chartData: [],
            tableData: [],
            exportBaseHistory,
            exportDiaShow: false,
            eForm: {}
        };
    },
    methods: {
        unitChange(name) {
            this.unitArray.forEach(item => {
                if (name === item.key) {
                    this.unitObj = item;
                }
            });
            this.SearchForm.probe = name;
            // this.token = null;
            this.count = 0;
            this.getData();
        },
        // 选择设备
        selectDevice(row) {
            this.SearchForm.iDisplayStart = 0;
            this.SearchForm.iDisplayLength = 10;

            // 改变设备和页数并且重新获取列表
            this.activeDeviceId = row;
            // 重新获取列表逻辑
            this.getDeviceInfo();
        },

        // 获取历史数据
        getData() {
            // 06-30 ~ 07-04
            const { baseNo } = this.$route.query;
            this.SearchForm.plinthNo = baseNo;
            const [from, to] = this.timeRange;

            this.SearchForm.from = from || undefined;
            this.SearchForm.to = to || undefined;
            getHistoryData(this.SearchForm).then(({ result }) => {
                const token = result.token;
                if (token) this.token = token;
                const from = result.dafaultForm;
                const to = result.dafaultTo;
                this.SearchForm.from = from;
                this.SearchForm.to = to;
                this.SearchForm.startTime = from;
                this.SearchForm.endTime = to;
                this.timeRange = [from, to];
                this.deviceList = result.sensorNoList;
                // 默认选中
                if (result.sensorNoList && result.sensorNoList.length) {
                    this.activeDeviceId = this.deviceList[0];

                    this.getDeviceInfo();
                }
                this.chartData = {
                    max: result.max,
                    min: result.min,
                    data: result.data,
                    rangeData: result.rangeData || []
                };
            });
        },
        // 获取设备数据
        getDeviceInfo() {
            const [startTime, endTime] = this.deviceTimeRange;
            getHistoryData({ ...this.SearchForm, tab: 1, token: this.token, sensorNo: this.activeDeviceId, startTime, endTime }).then(({ result }) => {
                const { pageInfo, result: data } = result.page || {};
                if (pageInfo) {
                    this.tableData = data;
                    this.total = pageInfo.total;
                } else {
                    this.total = 0;
                    this.tableData = [];
                }
            });
        },
        updateUnit() {
            this.unitArray[0] = {
                key: 'temp',
                unit: store.state.unit['temp'].name,
                yText: `${$t('public.temp')}(${store.state.unit['temp'].name})`
            };
            this.unitArray[1] = {
                key: 'hum',
                unit: store.state.unit['hum'].name,
                yText: `${$t('public.hum')}(${store.state.unit['hum'].name})`
            };
            if (!Object.keys(this.unitObj).length) {
                this.unitObj = this.unitArray[0];
            }
        },
        // 查看数据
        viewData() {
            this.getDeviceInfo();
        },
        // 分析数据
        analData() {
            this.getData();
        },
        download() {
            const { carrierId, code, startTime, endTime } = this.SearchForm;
            console.log(this.SearchForm);

            const { baseNo } = this.$route.query;

            if (startTime.length === 0)
                return this.$message.warning($t('integration.time_cannot_be_empty'));
            this.eForm = {
                no: baseNo,
                startTime: startTime,
                endTime: endTime
            };

            this.exportDiaShow = true;
            this.$nextTick(() => {
                this.$refs['dia'].initForm();
            });
        }
    },
    mounted() {
        // this.getInfo();
        this.getData();
        store.dispatch('unit').then(res => {
            this.updateUnit();
        });
    }
};
</script>
